import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import FaTicket from 'react-icons/lib/fa/ticket';
import FaTruck from 'react-icons/lib/fa/truck';
import MdFileDownload from 'react-icons/lib/md/file-download';
import MdEmail from 'react-icons/lib/md/email';
import MdPhoneIphone from 'react-icons/lib/md/phone-iphone';

import Caption from '../../../typography/Caption';

const Row = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: props.justifyContent,
  marginBottom: props.marginBottom,
}));

const IconContainer = glamorous.div(props => ({
  padding: 8,
  border: `1px solid ${props.theme.default.lightest}`,
  marginRight: 8,
}));


const styleDeliveryOptionsRow = {
  alignItems: 'center',
  marginBottom: 8,
};

const deliveryOptions = {
  email: {
    Icon: MdEmail,
    label: 'Email, Download & Print',
  },
  instantDownload: {
    Icon: MdFileDownload,
    label: 'Download & Print Instantly',
  },
  localPickup: {
    Icon: FaTruck,
    label: 'Pickup or Ship',
  },
  mobileEntry: {
    Icon: MdPhoneIphone,
    label: 'SmartPhone Entry',
  },
  paperless: {
    Icon: FaTicket,
    label: 'Paperless',
  },
};

class DeliveryOptions extends React.PureComponent {
  static propTypes = {
    isElectronic: PropTypes.bool.isRequired,
    isInstant: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
  };

  renderIcon() {
    const {
      isInstant,
      isMobile,
      isElectronic,
    } = this.props;

    if (isInstant) {
      return deliveryOptions.instantDownload;
    } else if (isMobile) {
      return deliveryOptions.mobileEntry;
    } else if (isElectronic) {
      return deliveryOptions.email;
    }

    return {};
  }

  render() {
    const { label, Icon } = this.renderIcon();

    if (Icon) {
      if (this.props.isIconOnly) {
        return (
          <Icon style={{ marginLeft: 8, verticalAlign: 'top' }} size={18} />
        );
      }

      return (
        <Row style={styleDeliveryOptionsRow}>
          <IconContainer>
            <Icon size={32} color="#e0e0e0" />
          </IconContainer>
          <Caption weight="bold">{label}</Caption>
        </Row>
      );
    }

    return null;
  }
}

export default DeliveryOptions;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/Sidebar/DeliveryOptions.js